import Reset from 'components/auth/Reset';

export default {
  path: 'reset-password/:email/:token',
  component: Reset
};
